import { useContext } from 'react';
import { AppContext } from '../../contexts/context';

import Avatar from '@mui/material/Avatar';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/styles';

import { useGetLogo } from '../AppUtils';
import packageInfo from '../../../package.json';

export const AppInfoCard = (props) => {
  const [ state ] = useContext(AppContext);
  const appEnv = state.appEnv
  const theme = useTheme()

  var appLogo = useGetLogo();
  const appTitle = `About ${state.appManifestShortName}`

  return (
    <Card sx={{
        border: '1px solid',
        borderColor: theme.palette.primary.main,
        borderRadius: 5,
        display: "flex",
        flexDirection: "column",
        paddingX: 2,
        boxShadow: "none",
        alignItems: "left",
        justifyContent: "left"
      }}>
      <CardHeader
          avatar={
            <Avatar
              sx={{
                width:60,
                height:60,
                bgcolor: theme.palette.primary.dark,
                }}
              variant="rounded"
              aria-label="Logo"
              alt="Logo"
              src={appLogo}
            />
          }
          title={appTitle}
          subheader= { appEnv === 'prd'
                        ? <>v{packageInfo.version}-{process.env.REACT_APP_GIT_HASH}</>
                        : appEnv === 'stg'
                          ? <> Version: v{packageInfo.version} <br/> {process.env.REACT_APP_GIT_HASH}-stg</>
                          : <> Version: v{packageInfo.version} <br/> {process.env.REACT_APP_GIT_HASH}-dev</>
                      }
          titleTypographyProps={{marginLeft:0, color:"text.primary", variant:"h6", fontWeight: 'normal'}}
          sx={{mb:0}}
      />
      {state.brandShowLabel && (
        <CardContent sx={{mt:0, pt:0, pb:0}}>
          <Typography variant="body2" color="text.primary">
            {state.brandName}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {state.brandTitle}
          </Typography>
        </CardContent>
      )}
    </Card>
  )
}

export default AppInfoCard;
